// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2rC05","inputWrap":"styles_inputWrap__1t0DR","input":"styles_input__3CX2B"};